import { createFileRoute } from "@tanstack/react-router";

import TestPortals from "../pages/TestPortals";
import { RequireAuth } from "../utils/RequireAuth";

export const Route = createFileRoute("/_shell/test-portals")({
  component: TestPortalsRoute,
});

function TestPortalsRoute() {
  return (
    <RequireAuth require="chatbotAccess">
      <TestPortals />
    </RequireAuth>
  );
}
